(() => {
  const buttonSelector = '[data-load-country-flags]';

  const loadCountryFlags = (button) => {
    if (button.dataset.countryFlagsLoaded === 'true') return;

    const localizationForm = button.closest('localization-form');
    if (!localizationForm) return;

    localizationForm.querySelectorAll('img[data-country-flag-src]').forEach((image) => {
      image.src = image.dataset.countryFlagSrc;
      image.removeAttribute('data-country-flag-src');
    });
    button.dataset.countryFlagsLoaded = 'true';
  };

  const loadFromEvent = (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest(buttonSelector);
    if (button) loadCountryFlags(button);
  };

  document.addEventListener('pointerdown', loadFromEvent, true);
  document.addEventListener('click', loadFromEvent, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') loadFromEvent(event);
  });
})();
